import React, { useLayoutEffect, useRef, useState } from "react";
import { filters as filtersDrawer } from "@axum/ax-design/dist/js";
import { TABLE_MEDIA } from "../../Common/Orders/styles";
import { TableRoom } from "../../../config/tableRoom";

// Sin el panel la página puede perder la barra de scroll y oscilar entre entrar y no entrar.
const SLACK_TO_RETURN = 24;

// Calculado y no medido: cedido, el panel no está en su columna para medirlo.
const panelShare = (layout: HTMLElement) => {
  const probe = document.createElement("div");
  probe.style.cssText = "position:absolute;visibility:hidden;width:var(--ax-sidebar-w)";
  layout.appendChild(probe);
  const width = probe.offsetWidth;
  probe.remove();
  return width + (parseFloat(getComputedStyle(layout).columnGap) || 0);
};

export const useCededFilters = (view: React.RefObject<HTMLElement>, floating: boolean, room: TableRoom | null) => {
  const [ceded, setCeded] = useState(false);
  const needAtCede = useRef(0);

  useLayoutEffect(() => {
    const layout = view.current && view.current.querySelector<HTMLElement>(".ax-view-layout");
    const inColumn = Boolean(layout) && !floating && window.matchMedia(TABLE_MEDIA).matches;
    let cede = false;
    if (layout && room && inColumn) {
      const withPanel = ceded ? room.available - panelShare(layout) : room.available;
      const slack = ceded && room.need >= needAtCede.current ? SLACK_TO_RETURN : 0;
      cede = room.need > withPanel - slack;
    }
    if (cede === ceded) return;
    if (cede && room) needAtCede.current = room.need;
    // Antes de devolverlo a su columna: después el botón "Filtros" se oculta y el cierre no tiene adónde devolver el foco.
    if (!cede && inColumn) filtersDrawer.hide();
    setCeded(cede);
  }, [view, floating, room, ceded]);

  return ceded;
};
